import { render } from "./OurActivity.vue?vue&type=template&id=356830cf&scoped=true"
import script from "./OurActivity.vue?vue&type=script&lang=js"
export * from "./OurActivity.vue?vue&type=script&lang=js"

import "./OurActivity.vue?vue&type=style&index=0&id=356830cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356830cf"]])

export default __exports__